<template>
  <div class="print">
    <loader v-show="loading" />
    <div class="table-responsive" style="margin-bottom: 200px">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>No</th>
            <th>Tanggal</th>
            <th>Faktur</th>
            <th>Customer</th>
            <th>Petugas</th>
            <th>Kode Item & Garansi</th>
            <th>Nama</th>
            <th>Qty</th>
            <th>HPP</th>
            <th>Jual</th>
            <th>Laba</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody v-if="report.data && report.data.length <= 0">
          <tr>
            <td colspan="12" class="center">
              Data tidak ditemukan untuk range tanggal
              <strong
                >{{ this.dateRange.startDate.format("DD-MMM-YYYY") }} sd.
                {{ this.dateRange.endDate.format("DD-MMM-YYYY") }}</strong
              >
            </td>
          </tr>
        </tbody>
        <tbody v-else v-for="(v, k) in report.data" :key="k">
          <tr>
            <td :rowspan="v.details.length + 1">
              {{ k + 1 }}
            </td>
            <td style="width: 100px" :rowspan="v.details.length + 1">
              {{ v.created_at | dateTimeFormat }}
            </td>
            <td style="width: 120px" :rowspan="v.details.length + 1">
              {{ v.faktur }}
            </td>
            <td style="width: 220px" :rowspan="v.details.length + 1">
              {{ v.customer_name }}
            </td>
            <td style="width: 70px" :rowspan="v.details.length + 1">
              {{ v.user_name }}
            </td>
          </tr>

          <tr v-for="(d, ky) in v.details" :key="ky">
            <td style="width: 165px" class="center">
              {{ d.warranty_code }}
            </td>
            <td>{{ d.item_name }}</td>
            <td class="right" style="width: 41px; border-right: none">
              {{ d.qty }}
            </td>
            <td class="right" style="width: 90px; border-right: none">
              {{ d.hpp | thousandSeparator }}
            </td>
            <td class="right" style="width: 90px; border-right: none">
              {{ d.price | thousandSeparator }}
            </td>
            <td class="right" style="width: 80px; border-right: none">
              {{ d.laba | thousandSeparator }}
            </td>
            <td class="right" style="width: 90px; border-right: none">
              {{ d.sub_total | thousandSeparator }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue';
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: { Loader },
  data () {
    return {
      report: {},
      loading: false,
    }
  },
  computed: {
    startDate () {
      return this.$route.query.start_date;
    },
    endDate () {
      return this.$route.query.end_date;
    },
  },
  created () {
    this.get();
  },
  methods: {
    get () {
      this.loading = true
      const dateRange = `&start_date=${this.startDate}&end_date=${this.endDate}`;
      HTTPAUTH.get(
        `/api/v1/report-transaction/sale?size=10000&${dateRange}`
      ).then((res) => {
        this.loading = false;
        this.report = res.data;
      }).catch(() => {
        this.loading = false
      });
    },
    doPrint () {
      print();
      close();
    }
  }
};
</script>